export class ContextMenuExtension extends Autodesk.Viewing.Extension {
	private static readonly extensionCallbackName: string = "Autodesk.ContextMenuExtension";

	private preservedContextMenu: any;

	public constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
		super(viewer, {});
	}

	public load(): boolean {
		this.preservedContextMenu = (this.viewer as any).contextMenu;
		this.viewer.setContextMenu(null);

		return true;
	}

	public unload(): boolean {
		this.viewer.setContextMenu(this.preservedContextMenu);
		return true;
	}
}
